<template>
  <section class="outer info-video section-styling-0" v-if="context.item.modulvideoueberschrift">
    <div class="container">
      <h2 class="section-title">
        <span class="headline" v-html="context.item.modulvideoueberschrift"></span>
      </h2>
      <div class="column column-offset-10 column-80">
        <figure class="row video__figure">
          <video
            width="640"
            height="360"
            style="max-width: 100%"
            preload="none"
            controls
            playsinline
            webkit-playsinline
            class="video__video"
            id="Video"
            runat="server"
          >
            <source id="VideoSource" runat="server" />
          </video>
          <figcaption class="video__description">
            <p>TEXT</p>
          </figcaption>
          <noscript>
            <div class="box box--warning video__error">
              Medien-Inhalte können nur mit aktiviertem Javascript angezeigt werden
            </div>
          </noscript>
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModulInfoVideo',
  props: {
    context: {
      type: Object,
    },
  },
};
</script>
